import React from "react";
import ReactDOM from "react-dom";

export interface TabsPayload {
  scope: HTMLElement;
  tabs: HTMLElement[];
  showNavButtons: boolean;
}

interface TabsState {
  activeIndex: number;
}

interface TabsProps {
  payload: TabsPayload;
}

export class Tabs extends React.Component<TabsProps, TabsState> {
  get hasPrev(): boolean {
    return this.state.activeIndex - 1 >= 0;
  }

  get hasNext(): boolean {
    return this.state.activeIndex + 1 <= this.props.payload.tabs.length - 1;
  }

  constructor(props: TabsProps) {
    super(props);

    this.state = {
      activeIndex: 0
    };
  }

  prev(): void {
    if (this.hasPrev) this.setState({ activeIndex: this.state.activeIndex - 1 });
  }

  next(): void {
    if (this.hasNext) this.setState({ activeIndex: this.state.activeIndex + 1 });
  }

  setActiveTab(activeIndex: number): void {
    this.setState({ activeIndex });
  }

  render() {
    const { tabs, showNavButtons } = this.props.payload;

    return (
      <div>
        <div className="tabs__header">
          {tabs.map((tab, index) => {
            return (
              <div
                onClick={() => this.setActiveTab(index)}
                key={`tab${index}`}
                className={`tabs__headerItem ${index === this.state.activeIndex ? "tabs__headerItem--active" : ""}`}
              >
                <span dangerouslySetInnerHTML={{ __html: tab.getAttribute("data-tabTitle") }} />
              </div>
            );
          })}
        </div>

        {tabs.map((tab, index) => {
          return (
            <div
              key={`tab${index}`}
              className={`tabs__itemWrap ${index === this.state.activeIndex ? "tabs__itemWrap--active" : ""}`}
              dangerouslySetInnerHTML={{ __html: tab.outerHTML }}
            />
          );
        })}

        {showNavButtons ? (
          <nav className="tabs__nav">
            <div
              className={`tabs__navItem tabs__navItem--prev ${this.hasPrev ? "" : "tabs__navItem--disabled"}`}
              onClick={() => this.prev()}
            />
            <div
              className={`tabs__navItem tabs__navItem--next ${this.hasNext ? "" : "tabs__navItem--disabled"}`}
              onClick={() => this.next()}
            />
          </nav>
        ) : null}
      </div>
    );
  }
}
